module.exports = {"431225100":"林城镇","431225101":"坪村镇","431225102":"堡子镇","431225103":"团河镇","431225104":"若水镇","431225106":"广坪镇","431225107":"马鞍镇","431225108":"金竹镇","431225200":"沙溪乡","431225201":"金子岩侗族苗族乡","431225204":"高椅乡","431225209":"宝田侗族苗族乡","431225210":"漠滨侗族苗族乡","431225211":"蒲稳侗族苗族乡","431225212":"青朗侗族苗族乡","431225213":"炮团侗族苗族乡","431225214":"地灵乡","431225215":"连山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431225.json
// module id = 1754
// module chunks = 0